import _ from 'lodash';
import React, {Component} from "react";
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import {withFirebase} from 'react-redux-firebase';
import {Helmet} from "react-helmet";

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Hidden from "@material-ui/core/Hidden";
import Typography from '@material-ui/core/Typography';

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import Button from "components/CustomButtons/Button.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";
import LoadingSpinner from 'utils/LoadingSpinner/';
import {createPoll, uploadPicToS3} from '../../actions';

// Sections for this page
import ShareSection from "./ShareSection.js";
import PollSection from "./PollSection.js";
import MetaSection from "./MetaSection.js";
import TweetSection from "./TweetSection.js";
import DisqusSection from "./DisqusSection.js";

class PollPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      poll: {
        loading: false,
      },
      saveImgBlobForCreatePage : false,
    };
  }

  componentWillMount() {
    const {history} = this.props;
    if (this.props.location.state) {
      const {previewData} = this.props.location.state;
      this.setState({poll: {data: previewData}});
    } else {
      // TODO we should prompt the user that there is no data!?!
      history.push({pathname: '/poll/create'});
    }
    console.log('before the mount, reset');
    // this.props.resetPollData();
  }

  componentWillUnmount() {
    // reset poll data!!!?
    const {poll, saveImgBlobForCreatePage} = this.state;
    // wait to revoke the url in the preview page, if we nav to there
    if (poll.img && !saveImgBlobForCreatePage) {
      console.log('REVOKING IMG');
      window.URL.revokeObjectURL(poll.img.preview);
    }
  }

  // NOTE use arrow function here instead of binding this in constructor
  handleGoBackClick = () => {
    const {poll} = this.state;
    const fromPreviewData = poll.data;
    const navToCreatePage = () => this.props.history.push({
      pathname: '/poll/create',
      state: {fromPreviewData},
    });
    this.setState({saveImgBlobForCreatePage: true}, navToCreatePage);
  }

  handlePublishClick = () => {
    const {uploadPicToS3, auth, createPoll, history} = this.props;
    let {question, descrip, answers, img} = this.state.poll.data;
    // const {data} = this.state.poll;
    console.log(this.state.poll.data);
    answers = answers.map(a => a.answer);
    const token = auth.uid || 'ANONYMOUS';
    const img_url = `https://s3.us-east-2.amazonaws.com/pollpals-poll-imgs/${img.name}`;
    const pollData = {question, descrip, token, img_url, answers, thumb_url: img_url};

    const callback = () => createPoll(pollData, history);
    uploadPicToS3({img, callback});
  }

  renderPreviewConfirmSection() {
    const {classes} = this.props;
    return(
      <div className={classes.flexCenter}>
        <div className={classes.fixedPreviewContainer}>
          <div className={classes.flexCenterColumn}>
            <div style={{paddingTop: 10}}>
              <Typography color="secondary" variant="caption" style={{fontSize: 18, fontWeight: 500}}>
                Please confirm this poll preview looks as expected!
              </Typography>
            </div>
            <div style={{paddingTop: 10, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <Button style={{marginRight: 30}} onClick={this.handleGoBackClick} color="primary" size="sm">
                Go Back (edit)
              </Button>
              <Button onClick={this.handlePublishClick} color="primary" size="sm">
                {/* <Link to='#' style={{color: 'inherit'}} > */}
                  Publish Poll
                {/* </Link> */}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {classes, history, ...rest} = this.props;
    const {poll} = this.state;

    if (poll.loading || _.isEmpty(poll.data)) {
      return <LoadingSpinner />;
    }

    return (
      <div>
        <Header
          color="white"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        {this.renderPreviewConfirmSection()}
        <Parallax filter image={poll.data.img.preview}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Hidden only="xs">
                  <h1 className={classes.title}>{poll.data.question}</h1>
                  <br />
                  <a href="#poll" className={classes.voteButton}>VOTE NOW</a>
                </Hidden>
                <Hidden smUp>
                  <h1 className={classes.xsTitle}>{poll.data.question}</h1>
                </Hidden>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ShareSection isPreview previewData={poll.data}/>
          </div>
          <PollSection previewPoll={poll}/>
          <MetaSection previewPoll={poll}/>
        </div>
        <Footer />
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withStyles(landingPageStyle)(withFirebase(PollPreview));

function mapStateToProps(state) {
  return {
    auth: state.firebase.auth,
    poll: state.poll,
  };
}

export default withRouter(connect(mapStateToProps, {createPoll, uploadPicToS3})(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/PollPreview.js